"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoRadioQuestionWidget = void 0;
var React = require("react");
var journey_model_1 = require("@athena-portal/journey-model");
var FalconSelectQuestionWidgetBase_1 = require("../FalconSelectQuestionWidgetBase");
var InfoQuestionWrapper_1 = require("../../components/infoQuestion/InfoQuestionWrapper");
var journey_services_1 = require("@athena-portal/journey-services");
var services_1 = require("@falcon/services");
var InfoRadioQuestionWidget = exports.InfoRadioQuestionWidget = /** @class */ (function (_super) {
    __extends(InfoRadioQuestionWidget, _super);
    function InfoRadioQuestionWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        return _this;
    }
    InfoRadioQuestionWidget.prototype.render = function () {
        var label = this.props.question.label ? this.props.question.label : this.renderHtml(this.getSetting("labelHtml"));
        var info = this.renderHtml(this.getSetting("infoHtml"));
        return (React.createElement(InfoQuestionWrapper_1.InfoQuestionWrapper, { label: label, infoType: this.getSetting("infoType"), info: info, infoTitle: this.getSetting("infoTitle"), className: this.getSetting("cssClass"), hideInfoButton: this.isMtaAndDisabled() },
            this.renderInputField(),
            this.renderValidationResult()));
    };
    InfoRadioQuestionWidget.prototype.renderInputField = function () {
        var _this = this;
        var _a, _b;
        var radioButtons = [];
        // Setting whether to disable field is taken either from condition name specified as "disabled",
        // or from inputDisabled boolean setting as usual
        var radioType = this.getSetting("radioType");
        var disabled = this.getSetting("disabled");
        this.disabled = disabled
            ? journey_services_1.ConditionEvaluator.evaluateCondition(this.props.journey.displayConditions, disabled, this.props.interaction)
            : this.getSetting(services_1.INPUT_DISABLED_SETTING, false);
        if (this.state.lookupValues) {
            var validationErrors_1 = (_b = (_a = this.props.validations[this.props.question.name]) === null || _a === void 0 ? void 0 : _a.errors) !== null && _b !== void 0 ? _b : [];
            this.state.lookupValues.forEach(function (v, i) {
                radioButtons.push(_this.getRadioButton(v, i, validationErrors_1, radioType));
            });
        }
        return (React.createElement("div", { className: "form-group mb-0", id: this.props.question.name },
            React.createElement("div", { className: "input-group width-auto pb-0 ".concat(radioType == "radio" ? 'd-block' : ''), role: "group" }, radioButtons)));
    };
    InfoRadioQuestionWidget.prototype.isChecked = function (id) {
        return (id === "".concat(this.bindFromField(this.props.question.interactionField)));
    };
    InfoRadioQuestionWidget.prototype.getRadioButton = function (v, i, validationErrors, radioType) {
        if (radioType == "radio") {
            return (React.createElement("div", { className: "custom-control margin-bottom-20-padding-left-0 d-flex", key: i, onClick: this.executeNativeEvent },
                React.createElement("input", { className: "custom-radiobutton ".concat(validationErrors.length > 0 ? "is-invalid" : ""), type: "radio", name: this.props.question.name, id: this.props.question.name + v.id, value: v.id, checked: this.isChecked(v.id), onChange: this.handleOnChangeEvent, onBlur: this.handleOnBlurEvent, disabled: this.disabled }),
                React.createElement("label", { className: "checkbox-label label-bg-transparent", htmlFor: this.props.question.name + v.id }, this.renderHtml(v.value))));
        }
        else {
            return (React.createElement("div", { className: "custom-control custom-radio", key: i, onClick: this.executeNativeEvent },
                React.createElement("input", { className: "custom-control-input vehicle-details-radio ".concat(validationErrors.length > 0 ? "is-invalid" : ""), type: "radio", name: this.props.question.name, id: this.props.question.name + v.id, value: v.id, checked: this.isChecked(v.id), onChange: this.handleOnChangeEvent, onBlur: this.handleOnBlurEvent, disabled: this.disabled }),
                React.createElement("label", { className: "custom-control-label", htmlFor: this.props.question.name + v.id }, this.renderHtml(v.value))));
        }
    };
    InfoRadioQuestionWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "labelHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "infoType", type: journey_model_1.TypeDescriptions.String },
            { name: "infoTitle", type: journey_model_1.TypeDescriptions.String },
            { name: "infoHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "disabled", type: journey_model_1.TypeDescriptions.Number },
            { name: services_1.INPUT_DISABLED_SETTING, type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        __metadata("design:paramtypes", [Object])
    ], InfoRadioQuestionWidget);
    return InfoRadioQuestionWidget;
}(FalconSelectQuestionWidgetBase_1.FalconSelectQuestionWidgetBase));
//# sourceMappingURL=InfoRadioQuestionWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/infoQuestionWidgets/InfoRadioQuestionWidget.js
// module id = 1381
// module chunks = 0